// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2b5B4","signatureBlock":"Footer_signatureBlock__16FCj","signature":"Footer_signature__2qS4Z"};